/** Chave localStorage por usuário — etag visto do manifesto de plugins Moodle. */
export function pluginUpdateSeenStorageKey(userId) {
  return `geppetto_plugins_seen_etag_${userId || 'anon'}`;
}

export function readPluginUpdateSeenEtag(userId) {
  try {
    return localStorage.getItem(pluginUpdateSeenStorageKey(userId)) || '';
  } catch {
    return '';
  }
}

export function writePluginUpdateSeenEtag(userId, etag) {
  if (!etag) return;
  try {
    localStorage.setItem(pluginUpdateSeenStorageKey(userId), String(etag));
  } catch {
    /* ignore quota / private mode */
  }
}
